import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Categories = () => {
  const { categorys } = useSelector((state) => state.home);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mdtablet: {
      breakpoint: { max: 991, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 3,
    },
    smmobile: {
      breakpoint: { max: 640, min: 0 },
      items: 2,
    },
    xsmobile: {
      breakpoint: { max: 440, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="w-[87%] mx-auto py-5 relative justify-center text-center ">
      <div className="my-10 ">
        <h1 className="gradient-t0 text-[30px] sm:text-[20px] mb-2">
          {" "}
          فئات المنتجات
        </h1>
        <h2 className="gradient-t1 text-[22px] sm:text-[15px]">
          {" "}
          هنا مجموعة كبيرة ومتنوعة من فئات المنتجات الطبية
        </h2>
      </div>
      <Carousel
        autoPlay={true}
        infinite={true}
        arrows={true}
        responsive={responsive}
        transitionDuration={500}
      >
        {categorys.map((c, i) => (
          <Link
            className="m-5 block pb-8 items-center align-middle justify-center"
            key={i}
            to="/our-products"
          >
            <div className="w-[200px] sm:w-full h-full flex mt-20 px-2 py-5 justify-center align-middle items-center bg-mainBg relative  rounded-2xl shadow-lg border-2 border-mainColor">
              <div className=" absolute top-[-60px]">
                <img
                  src={c.image}
                  alt={c.name}
                  className="flex w-[80px] rounded-full border-2 border-mainColor"
                />
              </div>

              <div className="w-full mx-auto font-bold left-0 flex flex-col text-sm">
                {c.name.includes(" - ") ? (
                  <>
                    <span className="py-[2px] px-6 rounded-2xl gradient-t1 blurred-bg text-left">
                      {c.name.split(" - ")[0]}
                    </span>
                    <span className="py-[2px] px-6 rounded-2xl gradient-t1 blurred-bg text-right">
                      {c.name.split(" - ")[1]}
                    </span>
                  </>
                ) : (
                  <span className="py-[2px]  rounded-2xl gradient-t1 blurred-bg">
                    {c.name}
                  </span>
                )}
              </div>
            </div>
          </Link>
        ))}
      </Carousel>
    </div>
  );
};

export default Categories;
